/**
 * Utility for using assets across project
 * @params {path} path - reference for an asset based on the source chosen.
 * @params {Object} options - object for configuration.
 * @params {string} options.source - either 'kong'|'imageboss', there is no default yet for us to choose a better default in the future.
 */
export const asset = (path, { source } = {}) => {
  const slashedPath = (path?.startsWith('/')) ? path : `/${path}`

  const transformers = {
    kong: () => `https://kong.quero.com${slashedPath}`,
    imageboss: () => `https://img.imageboss.me/kong${slashedPath}`,
  }

  if (typeof transformers[source] !== 'function') {
    // eslint-disable-next-line no-console
    console.warn(`[$asset]: The source "${source}" is not valid, fallbacking to pure path`)

    return path
  }

  const transformedPath = transformers[source]()

  return transformedPath
}

export default (_, inject) => {
  inject('asset', asset)
  inject('yCdn', asset)
}
